import { useState } from 'react';

import { Page } from '../../components/shared/page/Page';
import { THEORY_SUBJECT_ID } from '../../constants/subjects';
import { ErrorReportAdminList } from '../../features/reports/components/error-report-admin-list/ErrorReportAdminList';
import {
  ErrorReportListFilter,
  ErrorReportListFilterForm,
} from '../../features/reports/components/error-report-list-filter/ErrorReportListFilter';

import styles from './ErrorReportListPage.module.scss';

function ErrorReportListPage() {
  const [filter, setFilter] = useState<ErrorReportListFilterForm>({
    fromTime: new Date(new Date().setMonth(new Date().getMonth() - 12)),
    toTime: new Date(new Date().setHours(23, 59, 59, 999)),
    sort: '-createdAt',
    subject: {
      id: THEORY_SUBJECT_ID,
      name: '',
    },
    statuses: ['open'],
  });

  return (
    <Page className={styles['page']}>
      <ErrorReportListFilter
        values={filter}
        onSubmit={(values) => {
          setFilter(values);
        }}
        onClear={() => {
          setFilter({
            fromTime: new Date(new Date().setMonth(new Date().getMonth() - 12)),
            toTime: new Date(new Date().setHours(23, 59, 59, 999)),
            sort: '-createdAt',
            subject: {
              id: THEORY_SUBJECT_ID,
              name: '',
            },
            statuses: ['open'],
          });
        }}
      />
      <ErrorReportAdminList filter={filter} />
    </Page>
  );
}

export { ErrorReportListPage };
